var axios = require("axios");

export const partnerInfo = async (content) => {
  const getNotNullValue = function (obj) {
    if ([undefined, null, "undefined", "null"].includes(obj)) {
      return "";
    }
    return obj;
  };

  let feishuData = {
    msg_type: "interactive",
    card: {
      header: {
        template: "yellow",
        title: {
          content: "📪 有渠道伙伴咨询，请及时联系~",
          tag: "plain_text",
        },
      },
      elements: [
        {
          fields: [
            {
              is_short: true,
              text: {
                content: "📚** 企业名称：**" + getNotNullValue(content.company),
                tag: "lark_md",
              },
            },
            {
              is_short: true,
              text: {
                content: "🔈 **企业邮箱：**" + getNotNullValue(content.email),
                tag: "lark_md",
              },
            },
            {
              is_short: false,
              text: {
                content: "",
                tag: "lark_md",
              },
            },

            {
              is_short: true,
              text: {
                content: "👤 **姓名：**" + getNotNullValue(content.name),
                tag: "lark_md",
              },
            },
            {
              is_short: true,
              text: {
                content: "🔈 **手机号：**" + getNotNullValue(content.phone),
                tag: "lark_md",
              },
            },

            {
              is_short: false,
              text: {
                content: "",
                tag: "lark_md",
              },
            },
            {
              is_short: true,
              text: {
                content:
                  "📌 **企业所在地：**" + getNotNullValue(content.address),
                tag: "lark_md",
              },
            },
            {
              is_short: true,
              text: {
                content: "🗂️ **合作方向：**" + getNotNullValue(content.intend),
                tag: "lark_md",
              },
            },
          ],
          tag: "div",
        },
      ],
    },
  };
  const res = await axios.post(
    "https://open.feishu.cn/open-apis/bot/v2/hook/8cf7cd62-acbc-42d9-9608-7f02ec0cb1cf",
    feishuData
  );
  return res;
};
